import { createElement, Fragment, createRef, Component } from 'react';
import DromoUploader from 'dromo-uploader-js';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var DromoReactUploader = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DromoReactUploader, _React$Component);

  function DromoReactUploader(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.inlineRef = null;

    _this.init = function () {
      if ('fields' in _this.props && 'settings' in _this.props) {
        _this.dromo = new DromoUploader(_this.props.licenseKey, _this.props.fields, _this.props.settings, _this.props.user);
      } else if ('schemaId' in _this.props || 'schemaName' in _this.props) {
        var idOrName = 'schemaId' in _this.props ? _this.props.schemaId : _this.props.schemaName;
        _this.dromo = new DromoUploader(_this.props.licenseKey, idOrName);

        if ('developmentMode' in _this.props) {
          _this.dromo.setDevelopmentMode(_this.props.developmentMode);
        }

        if ('user' in _this.props) {
          _this.dromo.setUser(_this.props.user);
        }

        if ('headerRowOverride' in _this.props) {
          _this.dromo.setHeaderRowOverride(_this.props.headerRowOverride);
        }
      }

      if (_this.props.rowHooks) {
        _this.props.rowHooks.forEach(function (hook) {
          return _this.dromo.registerRowHook(hook);
        });
      }

      if (_this.props.bulkRowHooks) {
        _this.props.bulkRowHooks.forEach(function (hook) {
          return _this.dromo.registerBulkRowHook(hook);
        });
      }

      if (_this.props.columnHooks) {
        _this.props.columnHooks.forEach(function (hook) {
          _this.dromo.registerColumnHook(hook.fieldName, hook.callback);
        });
      }

      if (_this.props.rowDeleteHooks) {
        _this.props.rowDeleteHooks.forEach(function (hook) {
          return _this.dromo.registerRowDeleteHook(hook);
        });
      }

      if (_this.props.beforeFinish) {
        _this.dromo.beforeFinish(_this.props.beforeFinish);
      }

      if (_this.props.onResults) {
        _this.dromo.onResults(_this.props.onResults);
      }

      if (_this.props.onCancel) {
        _this.dromo.onCancel(_this.props.onCancel);
      }

      if (_this.props.stepHooks) {
        _this.props.stepHooks.forEach(function (hook) {
          _this.dromo.registerStepHook(hook.type, hook.callback);
        });
      }

      if (_this.props.fileParsers) {
        _this.props.fileParsers.forEach(function (parser) {
          _this.dromo.registerFileParser(parser);
        });
      }
    };

    _this.open = function () {
      _this.init();

      _this.dromo.open();
    };

    _this.initInline = function () {
      if (!_this.inlineRef) return;

      _this.init();

      _this.dromo.initInline(_this.inlineRef.current);
    };

    if (props.inline) {
      _this.inlineRef = createRef();
    }

    return _this;
  }

  var _proto = DromoReactUploader.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.inline && this.inlineRef) {
      this.initInline();
      return;
    }

    if (this.props.open) this.open();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.inline) {
      this.initInline();
      return;
    }

    if (!prevProps.open && this.props.open) {
      this.open();
    }

    if (prevProps.open && !this.props.open) {
      this.dromo.close();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.open && !this.props.inline) {
      this.dromo.close();
    }
  };

  _proto.render = function render() {
    if (this.props.inline) {
      return createElement("div", {
        ref: this.inlineRef,
        className: this.props.className,
        style: this.props.style
      });
    }

    if (this.props.children === undefined) return createElement(Fragment, null);
    return createElement("button", {
      style: this.props.style,
      className: this.props.className,
      onClick: this.open
    }, this.props.children);
  };

  return DromoReactUploader;
}(Component);

export default DromoReactUploader;
//# sourceMappingURL=index.modern.js.map
